// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_CompanyListPagingResultModel from '../../model/tdg-company-list-paging-result-model';
import Tdg_CompanyListPagingResultDTO from '../dto/tdg-company-list-paging-result-dto';
import dtoSchema from '../schemas/tdg-company-list-paging-result-schema';
import Tdg_CompanyListModel from '../../model/tdg-company-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class Tdg_CompanyListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_CompanyListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => Tdg_CompanyListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: Tdg_CompanyListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<Tdg_CompanyListPagingResultDTO>): Tdg_CompanyListPagingResultModel;
  static toModel(dto: DeepPartial<Tdg_CompanyListPagingResultDTO> | undefined | null): Tdg_CompanyListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<Tdg_CompanyListPagingResultDTO> | undefined | null): Tdg_CompanyListPagingResultModel | undefined {
    return dto ? new Tdg_CompanyListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_CompanyListPagingResultModel> | Tdg_CompanyListPagingResultModel): Tdg_CompanyListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as Tdg_CompanyListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_CompanyListPagingResultModel, can not map to Tdg_CompanyListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
